import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Home, ArrowLeft, Search } from 'lucide-react';

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#0f1419] flex items-center justify-center px-4">
      <div className="max-w-2xl mx-auto text-center">
        {/* 404 Number */}
        <div className="mb-8">
          <h1 className="text-9xl font-bold text-emerald-400 mb-4 animate-pulse">
            404
          </h1>
          <div className="h-1 w-32 bg-emerald-500 mx-auto rounded-full"></div>
        </div>

        {/* Message */}
        <div className="mb-8">
          <h2 className="text-3xl sm:text-4xl font-bold text-white mb-4">
            Page Not Found
          </h2>
          <p className="text-gray-400 text-lg leading-relaxed">
            Oops! The page you're looking for doesn't exist. It might have been moved or deleted.
          </p>
        </div>

        {/* Icon */}
        <div className="mb-8">
          <div className="w-24 h-24 bg-emerald-500/10 rounded-full flex items-center justify-center mx-auto">
            <Search size={48} className="text-emerald-400" />
          </div>
        </div>

        {/* Action Buttons */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Button
            onClick={() => navigate('/')}
            className="bg-emerald-500 hover:bg-emerald-600 text-white px-8 py-6 text-lg rounded-md transition-all duration-300 hover:shadow-lg hover:shadow-emerald-500/50"
          >
            <Home className="mr-2" size={20} />
            Go to Home
          </Button>
          <Button
            variant="outline"
            className="border-2 border-emerald-500 text-emerald-400 hover:bg-emerald-500/10 px-8 py-6 text-lg rounded-md transition-all duration-300"
            onClick={() => navigate(-1)}
          >
            <ArrowLeft className="mr-2" size={20} />
            Go Back
          </Button>
        </div>

        {/* Additional Links */}
        <div className="mt-12">
          <p className="text-gray-500 text-sm mb-4">You might be looking for:</p>
          <div className="flex flex-wrap items-center justify-center gap-4">
            <button
              onClick={() => navigate('/#about')}
              className="text-emerald-400 hover:text-emerald-300 transition-colors text-sm"
            >
              About
            </button>
            <span className="text-gray-700">•</span>
            <button
              onClick={() => navigate('/#experience')}
              className="text-emerald-400 hover:text-emerald-300 transition-colors text-sm"
            >
              Experience
            </button>
            <span className="text-gray-700">•</span>
            <button
              onClick={() => navigate('/#projects')}
              className="text-emerald-400 hover:text-emerald-300 transition-colors text-sm"
            >
              Projects
            </button>
            <span className="text-gray-700">•</span>
            <button
              onClick={() => navigate('/#contact')}
              className="text-emerald-400 hover:text-emerald-300 transition-colors text-sm"
            >
              Contact
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
